export function createSessionExpiredCookie(exdays) {
  const d = new Date();

  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

  console.log('expires=', d.toUTCString());
  const expires =
    'expires=' +
    (exdays === 0 ? 'Thu, 01 Jan 1970 00:00:00 UTC' : d.toUTCString());

  document.cookie = `sessionExpired=true; ${expires}; path=/`;
}

export function sessionExpiredCookie() {
  const name = 'sessionExpired=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}



// WEBPACK FOOTER //
// ./js/components/global/AccountsExpirationSessionCookie.js